import Phaser from 'phaser';
import { WeaponType } from '../utils/constants';

export type WeaponVisualVariant = 'v1' | 'v2' | 'v3' | 'v4' | 'v5';

export const WEAPON_CARD_TEXTURE_KEYS = [
  'weapon-card-v1',
  'weapon-card-v2',
  'weapon-card-v3',
  'weapon-card-v4',
  'weapon-card-v5',
] as const;

export const WEAPON_GUN_TEXTURE_KEYS = [
  'weapon-gun-v1',
  'weapon-gun-v2',
  'weapon-gun-v3',
  'weapon-gun-v4',
  'weapon-gun-v5',
] as const;

const WEAPON_VARIANT_BY_TYPE: Record<WeaponType, WeaponVisualVariant> = {
  [WeaponType.Pistol]: 'v1',
  [WeaponType.Rifle]: 'v2',
  [WeaponType.MachineGun]: 'v3',
  [WeaponType.Rocket]: 'v5',
};

const WEAPON_DISPLAY_NAMES: Record<WeaponType, string> = {
  [WeaponType.Pistol]: 'PISTOL',
  [WeaponType.Rifle]: 'RIFLE',
  [WeaponType.MachineGun]: 'MACHINE GUN',
  [WeaponType.Rocket]: 'ROCKET',
};

export function getWeaponVisualVariant(weapon: WeaponType): WeaponVisualVariant {
  return WEAPON_VARIANT_BY_TYPE[weapon];
}

export function getWeaponCardTextureKey(weapon: WeaponType): string {
  return `weapon-card-${getWeaponVisualVariant(weapon)}`;
}

export function getWeaponGunTextureKey(weapon: WeaponType): string {
  return `weapon-gun-${getWeaponVisualVariant(weapon)}`;
}

export function getWeaponDisplayName(weapon: WeaponType): string {
  return WEAPON_DISPLAY_NAMES[weapon];
}

export function fitImageContain(
  image: Phaser.GameObjects.Image,
  maxWidth: number,
  maxHeight: number
): void {
  const baseWidth = Math.max(1, image.width);
  const baseHeight = Math.max(1, image.height);
  const scale = Math.min(maxWidth / baseWidth, maxHeight / baseHeight);
  image.setScale(scale);
}
